// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 8715) return "static/chunks/8715-90953bc86647e771.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3491":"e2359d37adff9bf4","8947":"b9fd4e1d1a090a6d"}[chunkId] + ".js";
};